/**
 * Helpers do método "Cartão de crédito" — modo demonstração.
 *
 * Sem validação Luhn de propósito: qualquer 13-19 dígitos passa.
 * Detecção de bandeira por prefixo bate na maioria dos cartões reais.
 */

export type CardBrand = 'visa' | 'mastercard' | 'amex' | 'elo' | 'unknown';

export const CARD_BRAND_LABEL: Record<CardBrand, string> = {
  visa: 'VISA',
  mastercard: 'MASTERCARD',
  amex: 'AMEX',
  elo: 'ELO',
  unknown: 'CARTÃO',
};

export function detectBrand(digits: string): CardBrand {
  const d = digits.replace(/\D/g, '');
  if (d.length === 0) return 'unknown';
  if (/^4/.test(d)) return 'visa';
  if (/^(5[1-5]|2[2-7])/.test(d)) return 'mastercard';
  if (/^3[47]/.test(d)) return 'amex';
  if (/^(4011|431274|438935|451416|457393|504175|506699|509|627780|636297|636368|65003[1-3]|65003[5-9]|65004|65005|65041|6505[6-9]|65070|65072|65090|65165[2-9])/.test(d)) {
    return 'elo';
  }
  return 'unknown';
}

/** Formata "1234567812345678" → "1234 5678 1234 5678" (4-4-4-4 ou 4-6-5 AMEX). */
export function maskCardNumber(raw: string, brand: CardBrand): string {
  const d = raw.replace(/\D/g, '');
  if (brand === 'amex') {
    // 4-6-5
    return d.replace(/^(\d{4})(\d{0,6})(\d{0,5}).*/, (_m, a, b, c) =>
      [a, b, c].filter(Boolean).join(' '),
    );
  }
  // 4-4-4-4 (até 19 dígitos pra cartões longos tipo Maestro)
  return d.replace(/(\d{4})(?=\d)/g, '$1 ');
}

/** Formata "1224" → "12/24". Aceita "1/24" parcial enquanto digita. */
export function maskExpiry(raw: string): string {
  const d = raw.replace(/\D/g, '').slice(0, 4);
  if (d.length <= 2) return d;
  return `${d.slice(0, 2)}/${d.slice(2)}`;
}

/** Últimos 4 dígitos pra exibir no detailsFake ("VISA ****4242"). */
export function last4(digits: string): string {
  const d = digits.replace(/\D/g, '');
  return d.length >= 4 ? d.slice(-4) : d.padStart(4, '·');
}

/** Tamanho mínimo válido por bandeira (sem Luhn). */
export function minDigitsFor(brand: CardBrand): number {
  return brand === 'amex' ? 15 : 13;
}
